import React from 'react';
import PropTypes from 'prop-types';
import i53 from 'assets/images/i53.svg';
import i54 from 'assets/images/i54.svg';
import { css } from 'react-emotion';

const propTypes = {
  name: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  showSpaceError: PropTypes.bool,
};

const defaultProps = {
  showSpaceError: true,
};

class PatchInput extends React.Component {
  constructor() {
    super();
    this.state = { fetching: false, error: false, success: false, baseValue: null };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.enterListener = this.enterListener.bind(this);
    this.timeout = null;
    this.input = null;
  }

  componentDidMount() {
    this.setState({ baseValue: this.props.value });
  }

  async handleSubmit() {
    const { name, submit, value } = this.props;
    if(value === this.state.baseValue) return false;
    this.setState({ fetching: true, success: false });
    try {
      await submit({ [name]: value });
      this.setState({ fetching: false, success: true, baseValue: value });
      this.timeout = setTimeout(() => {
        this.setState({ success: false });
      }, 3000);
    } catch (err) {
      this.setState({ fetching: false, error: err[name] || err.message, success: false });
    }
  }

  handleBlur() {
    this.handleSubmit();
  }
  
  enterListener(e) {
    if (e.keyCode !== 13) return false;
    this.input.blur();
  }

  handleChange(e) {
    const { name } = this.props;
    clearTimeout(this.timeout);
    this.props.onChange({ [name]: e.target.value });
    if (this.state.error || this.state.success) this.setState({ error: false, success: false });
  }

  getError() {
    const { showSpaceError } = this.props;
    const { error } = this.state;
    if (showSpaceError) {
      return (
        <div className={errorClass}>{error && typeof error === 'string' && error}</div>
      );
    }
    if (error && typeof error === 'string') {
      return (
        <div className={errorClass}>{error}</div>
      );
    }
    return null;
  }

  render() {
    const { className = '', value, type = 'text', placeholder, disabled, tag } = this.props;
    const Tag = tag === 'textarea' ? 'textarea' : 'input';
    
    return (
      <div className="form-field">
        <Tag
          className={` nomargin ${className}`}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onKeyUp={this.enterListener}
          type={type}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          ref={node => this.input = node}
        />
        <Status {...this.state} />
        {this.getError()}
      </div>
    );
  }
}


PatchInput.propTypes = propTypes;
PatchInput.defaultProps = defaultProps;
export default PatchInput;


const Status = ({ success, fetching, error }) => {
  if (success) {
    return (
      <div className="valid-icon">
        <img src={i53} alt="" />
      </div>
    );
  } else if (fetching) {
    return <div className="loader" />;
  } else if (error) {
    return (
      <div className="valid-icon">
        <img src={i54} alt="" />
      </div>
    );
  } else {
    return null;
  }
};

Status.propTypes = {
  success: PropTypes.bool.isRequired,
  fetching: PropTypes.bool.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ]).isRequired,
}

const errorClass = css`
  font-size: 12px;
  font-weight: 600;
  color: #fc3666;
  min-height: 36px;
  margin-left: 40px;
`;


// WEBPACK FOOTER //
// ./src/components/form/PatchInput.jsx